import React from "react";
import { InputProps } from "../../Interfaces/InputProps";

const TextInput = ({
  label = "",
  value,
  onChange,
  placeholder,
  type = "text",
  className = "",
}: InputProps) => {
  const defaultClassName = `w-full border-[1px] px-2 py-2 rounded-lg mt-1 border-black-200 outline-none ${className}`;

  return (
    <div className="w-full mt-2">
      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        className={defaultClassName}
        autoCorrect="false"
        autoComplete="off"
      />
    </div>
  );
};

export default TextInput;
